import { CategoriesAndGamesType, CollectionType } from 'src/domains/casino/types/types';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { Common } from 'src/domains/common/Common';
import {
    apiGetCategoriesAndGamesRequest,
    ApiGetCategoriesAndGamesResponseType,
} from 'src/api_openapi/v2/casino-store/apiGetCategoriesAndGames';
// import {
//     apiGetRecentGamesRequest,
//     ApiGetRecentGamesResponse200Type,
//     ApiGetRecentGamesResponseType,
// } from 'src/api_openapi/v2/casino-store/apiGetRecentGames';
import {
    apiGetRecentGamesIdsRequest,
    ApiGetRecentGamesIdsResponse200Type,
    ApiGetRecentGamesIdsResponseType,
} from 'src/api_openapi/v2/casino-store/apiGetRecentGamesIds';
import { apiSetRecentGameRequest } from 'src/api_openapi/v2/casino-store/apiSetRecentGame';
// import {
//     apiGetFavouriteGamesRequest,
//     ApiGetFavouriteGamesResponse200Type,
//     ApiGetFavouriteGamesResponseType,
// } from 'src/api_openapi/v2/casino-store/apiGetFavouriteGames';
import {
    apiGetFavouriteGamesIdsRequest,
    ApiGetFavouriteGamesIdsResponse200Type,
    ApiGetFavouriteGamesIdsResponseType,
} from 'src/api_openapi/v2/casino-store/apiGetFavouriteGamesIds';
import { apiSetFavouriteGameRequest } from 'src/api_openapi/v2/casino-store/apiSetFavouriteGame';
import { CollectionClientType, CustomerClientType } from './adapter';
import { runAsync } from 'src_common/common/mobx-utils/runAsync';
import { autorun, computed, makeObservable, observable } from 'mobx';

export class StoreCollectionClient implements CollectionClientType {
    private readonly gatewayApiHost: string;
    private readonly authorization: string;

    private categoriesAndGamesResource: Resource<ApiGetCategoriesAndGamesResponseType>;
    @observable.ref public categoriesAndGames: CategoriesAndGamesType = {
        categories: [],
        games: [],
    };

    public constructor(
        private readonly collection: CollectionType,
        private readonly common: Common
    ) {
        makeObservable(this);
        this.gatewayApiHost = this.common.envVariables.gatewayApiHost ?? '';
        this.authorization = `Bearer ${this.common.session.currentJwt}`;

        this.categoriesAndGamesResource = new Resource(
            async (): Promise<ApiGetCategoriesAndGamesResponseType> =>
                apiGetCategoriesAndGamesRequest(
                    this.gatewayApiHost,
                    { collection_slug: this.collection },
                    { authorization: this.authorization }
                )
        );
        autorun((reaction) => {
            const result = this.categoriesAndGamesResource.get();
            if (result.type === 'ready' && result.value.status === 200) {
                this.categoriesAndGames = result.value.body;
                reaction.dispose();
            }
        });
    }

    @computed public get isLoading(): boolean {
        const result = this.categoriesAndGamesResource.get();
        return result.type === 'loading';
    }
}

// all commented values and methods will be used in casino store phase 2, please do not remove
export class StoreCustomerClient implements CustomerClientType {
    private readonly gatewayApiHost: string;
    private readonly authorization: string;

    private recentGamesIdsResource: Resource<ApiGetRecentGamesIdsResponseType>;
    // private recentGamesResource: Resource<ApiGetRecentGamesResponseType>;
    private favouriteGamesIdsResource: Resource<ApiGetFavouriteGamesIdsResponseType>;
    // private favouriteGamesResource: Resource<ApiGetFavouriteGamesResponseType>;

    public constructor(
        // private readonly collection: CollectionType,
        private readonly common: Common
    ) {
        this.gatewayApiHost = this.common.envVariables.gatewayApiHost ?? '';
        this.authorization = `Bearer ${this.common.session.currentJwt}`;

        this.recentGamesIdsResource = new Resource(
            async (): Promise<ApiGetRecentGamesIdsResponseType> =>
                apiGetRecentGamesIdsRequest(this.gatewayApiHost, {}, { authorization: this.authorization })
        );
        // this.recentGamesResource = new Resource(
        //     async (): Promise<ApiGetRecentGamesResponseType> =>
        //         apiGetRecentGamesRequest(
        //             this.gatewayApiHost,
        //             { collection_id: 1 },
        //             { authorization: this.authorization }
        //         )
        // );
        this.favouriteGamesIdsResource = new Resource(
            async (): Promise<ApiGetFavouriteGamesIdsResponseType> =>
                apiGetFavouriteGamesIdsRequest(this.gatewayApiHost, {}, { authorization: this.authorization })
        );
        // this.favouriteGamesResource = new Resource(
        //     async (): Promise<ApiGetFavouriteGamesResponseType> =>
        //         apiGetFavouriteGamesRequest(
        //             this.gatewayApiHost,
        //             { collection_id: 1 },
        //             { authorization: this.authorization }
        //         )
        // );
    }

    public get recentGamesIds(): ApiGetRecentGamesIdsResponse200Type {
        const result = this.recentGamesIdsResource.get();
        if (result.type === 'ready' && result.value.status === 200) {
            return result.value.body;
        }
        return [];
    }

    public get isLoadingRecent(): boolean {
        const result = this.recentGamesIdsResource.get();
        return result.type === 'loading';
    }

    public setRecentGame = (gameId: number): void => {
        runAsync(async () => {
            await apiSetRecentGameRequest(
                this.gatewayApiHost,
                {
                    requestBody: {
                        gameId,
                    },
                },
                { authorization: this.authorization }
            );
            // await this.recentGamesResource.refresh();
            await this.recentGamesIdsResource.refresh();
        });
    };

    // public get recentGames(): ApiGetRecentGamesResponse200Type {
    //     const result = this.recentGamesResource.get();
    //     if (result.type === 'ready' && result.value.status === 200) {
    //         return result.value.body;
    //     }
    //     return [];
    // }

    public get favouriteGamesIds(): ApiGetFavouriteGamesIdsResponse200Type {
        const result = this.favouriteGamesIdsResource.get();
        if (result.type === 'ready' && result.value.status === 200) {
            return result.value.body;
        }
        return [];
    }

    public get isLoadingFavourites(): boolean {
        const result = this.favouriteGamesIdsResource.get();
        return result.type === 'loading';
    }

    public setFavouriteGame = (gameId: number, isFavourite: boolean): void => {
        runAsync(async () => {
            await apiSetFavouriteGameRequest(
                this.gatewayApiHost,
                {
                    requestBody: {
                        gameId,
                        isFavourite,
                    },
                },
                { authorization: this.authorization }
            );
            // await this.favouriteGamesResource.refresh();
            await this.favouriteGamesIdsResource.refresh();
        });
    };

    // public get favouriteGames(): ApiGetFavouriteGamesResponse200Type {
    //     const result = this.favouriteGamesResource.get();
    //     if (result.type === 'ready' && result.value.status === 200) {
    //         return result.value.body;
    //     }
    //     return [];
    // }
}
